export const TOOLTIP_TITLE =
  'Your hours saved is calculated as an average of 5 hours per completed order. The hours saved is a cumulative calculation that is contributed to by address collection and validation, inventory selection, carrier logistics, employee communication, and more.';
